import React from 'react';
import Vimeo from '@u-wave/react-vimeo'; // eslint-disable-line import/no-unresolved
import ReactGA from 'react-ga4';

import VimeoWrapper from './vimeo.style';
import {GetParameter} from '../utils';

ReactGA.initialize(process.env.GATSBY_ANALYTICS_KEY);
var LOG = process.env.NODE_ENV == 'development' ? console.log.bind(console) : function () {};
LOG(process.env.GATSBY_ANALYTICS_KEY);

class VimeoPlayer extends React.Component {
  constructor(props) {
    super(props);
    var played = [];
    played[0] = false;
    var section = [];
    section[0] = false;
    section[1] = false;
    section[2] = false;
    section[3] = false;
    section[4] = false;
    section[5] = false;
    section[6] = false;
    section[7] = false;
    section[8] = false;
    section[9] = false;
    section[10] = false;
    this.state = {
      section: section
    };

    this.handlePlayerEnd = this.handlePlayerEnd.bind(this);
    this.handleTimeUpdate = this.handleTimeUpdate.bind(this);
  }

  handlePlayerEnd(data) {
    var analyticstracker = decodeURIComponent(GetParameter('g'));
    var address_trimmed = decodeURIComponent(GetParameter('t'));
    LOG('handlePlayerEnd: ' + analyticstracker);
    LOG('address: ' + address_trimmed);
    /* `seconds` indicates the current playback position of the video*/
    LOG('Played Time');
    ReactGA.event({
      category: analyticstracker,
      action: 'Played Time',
      value: data.seconds,
    });
    LOG('Complete');
    ReactGA.event({
      category: analyticstracker,
      action: 'Complete',
      value: address_trimmed,
    });
    this.setState({section: [false,false,false,false,false,false,false,false,false,false,false]});
  }

  handleTimeUpdate(data) {
    var analyticstracker = decodeURIComponent(GetParameter('g'));
    var address_trimmed = decodeURIComponent(GetParameter('t'));
    LOG('handleTimeUpdate: ' + analyticstracker);
    LOG('address: ' + address_trimmed);
    LOG('data: ' + data.seconds);
    LOG('section: ' + this.state.section);
    this.section = this.state.section;
    /* `seconds` indicates the current playback position of the video*/
    if (data.seconds >= 0 && data.seconds <= 6 && this.state.section[0] === false) {
      LOG('this.state.section[0]: ' + this.state.section[0]);
      LOG('Video Plays');
      ReactGA.event({
        category: analyticstracker,
        action: 'Video Plays',
        value: address_trimmed,
      });
      this.section[0] = true;
      this.setState({section: this.section});
    } else if (data.seconds >= 15 && data.seconds <= 16 && this.state.section[1] === false) {
      LOG('this.state.section[1]: ' + this.state.section[1]);
      LOG('Viewer made it to 15 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 15 seconds',
        value: address_trimmed,
      });
      this.section[1] = true;
      this.setState({section: this.section});
    } else if (data.seconds >= 30 && data.seconds <= 31 && this.state.section[2] === false) {
      LOG('this.state.section[2]: ' + this.state.section[2]);
      LOG('Viewer made it to 30 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 30 seconds',
        value: address_trimmed,
      });
      this.section[2] = true;
      this.setState({section: this.section});
    } else if (data.seconds >= 45 && data.seconds <= 46 && this.state.section[3] === false) {
      LOG('Viewer made it to 45 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 45 seconds',
        value: address_trimmed,
      });
      this.section[3] = true;
      this.setState({section: this.section});
    } else if (data.seconds >= 60 && data.seconds <= 61 && this.state.section[4] === false) {
      LOG('Viewer made it to 60 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 60 seconds',
        value: address_trimmed,
      });
      this.section[4] = true;
      this.setState({section: this.section});
    } else if (data.seconds >= 75 && data.seconds <= 76 && this.state.section[5] === false) {
      LOG('Viewer made it to 75 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 75 seconds',
        value: address_trimmed,
      });
      this.section[5] = true;
      this.setState({section: this.section});
    } else if (data.seconds >= 90 && data.seconds <= 91 && this.state.section[6] === false) {
      LOG('Viewer made it to 90 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 90 seconds',
        value: address_trimmed,
      });
      this.section[6] = true;
      this.setState({section: this.section});
    } else if (data.seconds >= 105 && data.seconds <= 106 && this.state.section[7] === false) {
      LOG('Viewer made it to 105 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 105 seconds',
        value: address_trimmed,
      });
      this.section[7] = true;
      this.setState({section: this.section});
    }
    else if (data.seconds >= 120 && data.seconds <= 121 && this.state.section[8] === false) {
      LOG('Viewer made it to 120 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 120 seconds',
        value: address_trimmed,
      });
      this.section[8] = true;
      this.setState({section: this.section});
    }
    else if (data.seconds >= 135 && data.seconds <= 136 && this.state.section[9] === false) {
      LOG('Viewer made it to 135 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 135 seconds',
        value: address_trimmed,
      });
      this.section[9] = true;
      this.setState({section: this.section});
    }
    else if (data.seconds >= 150 && data.seconds <= 151 && this.state.section[10] === false) {
      LOG('Viewer made it to 150 seconds');
      ReactGA.event({
        category: analyticstracker,
        action: 'Viewer made it to 150 seconds',
        value: address_trimmed,
      });
      this.section[10] = true;
      this.setState({section: this.section});
    }
  }

  render() {
    if (this.props.responsive) {
      return (
        <Vimeo
          video={decodeURIComponent(this.props.video_source)}
          responsive
          autoplay
          onEnd={this.handlePlayerEnd}
          onTimeUpdate={this.handleTimeUpdate}
          onPause={this.handlePlayerPause}
          onPlay={this.handlePlayerPlay}
          className='vimeoPlayer'
        />
      );
    } else {
      return (
        <VimeoWrapper>
          <Vimeo
            video={decodeURIComponent(this.props.video_source)}
            width={'800'}
            height={480}
            autoplay
            onEnd={this.handlePlayerEnd}
            onTimeUpdate={this.handleTimeUpdate}
            onPause={this.handlePlayerPause}
            onPlay={this.handlePlayerPlay}
            className='vimeoPlayer'
          />
        </VimeoWrapper>
      );
    }
  }
}

export default VimeoPlayer;
